import { useEffect, useState } from "react";

import { useApi } from "@/lib/api";

interface AssetRow {
  id: string;
  prompt: string | null;
  metadata_json: string;
}

export function ImageCard(props: { asset_id: string; caption?: string }) {
  const api = useApi();
  const [asset, setAsset] = useState<AssetRow | null>(null);
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let revoke: string | null = null;
    let cancelled = false;
    (async () => {
      try {
        const r = await api<{ asset: AssetRow }>(`/api/assets/${props.asset_id}`);
        if (cancelled) return;
        setAsset(r.asset);
        const fileRes = await fetch(`/api/assets/${props.asset_id}/file`, {
          credentials: "include",
        });
        if (!fileRes.ok) throw new Error(`file ${fileRes.status}`);
        const blob = await fileRes.blob();
        const url = URL.createObjectURL(blob);
        revoke = url;
        if (!cancelled) setSrc(url);
      } catch {
        //
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.asset_id]);

  return (
    <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
      {src ? (
        <img src={src} alt={asset?.prompt ?? "image"} className="w-full" />
      ) : (
        <div className="aspect-square animate-pulse bg-neutral-100" />
      )}
      {(props.caption || asset?.prompt) && (
        <div className="px-3 py-2 text-xs text-neutral-500">{props.caption ?? asset?.prompt}</div>
      )}
    </div>
  );
}
